import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'

Vue.component('VueDropzone', vue2Dropzone)
